<template>
    <div class="usage__paging">
        <ul>
            <!-- Go to first page -->
            <li
                class="prev"
                :class="{ disabled: props.modelValue === 1 }"
            >
                <a
                    id="pagination-first"
                    href="#"
                    @click.prevent="goToPage(1)"
                >
                    <span>＜＜</span>
                </a>
            </li>

            <!-- Previous page -->
            <li
                class="prev"
                :class="{ disabled: props.modelValue === 1 }"
            >
                <a
                    id="pagination-prev"
                    href="#"
                    @click.prevent="goToPage(props.modelValue - 1)"
                >
                    <span>＜</span>
                </a>
            </li>

            <!-- Visible pages -->
            <li
                v-for="page in visiblePages"
                :key="page"
                :class="{ 'is-active': page === props.modelValue }"
            >
                <a
                    :id="'pagination-' + page"
                    href="#"
                    @click.prevent="goToPage(page)"
                >
                    <span>{{ page }}</span>
                </a>
            </li>

            <!-- Next page -->
            <li
                class="next"
                :class="{ disabled: props.modelValue === props.length }"
            >
                <a
                    id="pagination-next"
                    href="#"
                    @click.prevent="goToPage(props.modelValue + 1)"
                >
                    <span>＞</span>
                </a>
            </li>

            <!-- Go to last page -->
            <li
                class="next"
                :class="{ disabled: props.modelValue === props.length }"
            >
                <a
                    id="pagination-last"
                    href="#"
                    @click.prevent="goToPage(props.length)"
                >
                    <span>＞＞</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    modelValue: {
        type: Number,
        default: 1,
    },
    length: {
        type: Number,
        required: true,
    },
});

const emit = defineEmits(["update:modelValue"]);

function goToPage(page) {
    if (
        page >= 1 &&
        page <= props.length &&
        page !== props.modelValue
    ) {
        emit("update:modelValue", page);
    }
}

const visiblePages = computed(() => {
    const totalPages = props.length;
    const currentPage = props.modelValue;

    const configuredLimit = Number(
        process.env.VUE_APP_PAGINATION_VISIBLE_PAGES_LIMIT
    );

    const maxVisible =
        Number.isInteger(configuredLimit) && configuredLimit > 0
            ? configuredLimit
            : 5;

    if (totalPages <= maxVisible) {
        return Array.from(
            { length: totalPages },
            (_, index) => index + 1
        );
    }

    const pagesBeforeCurrent = Math.floor(maxVisible / 2);

    let startPage = currentPage - pagesBeforeCurrent;
    let endPage = startPage + maxVisible - 1;

    if (startPage < 1) {
        startPage = 1;
        endPage = maxVisible;
    }

    if (endPage > totalPages) {
        endPage = totalPages;
        startPage = totalPages - maxVisible + 1;
    }

    return Array.from(
        { length: endPage - startPage + 1 },
        (_, index) => startPage + index
    );
});
</script>